export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: "Luckyho gym",
  description: "Pojd si zacvicit",
  Backend_URL : "https://luckyhogym.cz/api/",
  navItems: [
    {
      label: "Posilovna",
      href: "/WorkoutGym",
    },
    {
      label: "Elektroterapie",
      href: "/Elektrotherapy",
    },
    {
      label: "Tělocvična",
      href: "/SportGym",
    },
    {
      label: "Překážková dráha",
      href: "/ObstacleCourse",
    },
    {
      label: "Ceník",
      href: "/PayPlan",
    },
  ],
  navMenuItems: [
    {
      label: "Profile",
      href: "/profile",
    },
    {
      label: "Dashboard",
      href: "/dashboard",
    },
    {
      label: "Projects",
      href: "/projects",
    },
    {
      label: "Team",
      href: "/team",
    },
    {
      label: "Calendar",
      href: "/calendar",
    },
    {
      label: "Settings",
      href: "/settings",
    },
    {
      label: "Help & Feedback",
      href: "/help-feedback",
    },
    {
      label: "Logout",
      href: "/logout",
    },
  ],
  links: {
  },
};
